export const COMPONENT_NAME = "wallet-card";
